import { render } from "./OnePagerGalleryComponent.vue?vue&type=template&id=aea03f98"
import script from "./OnePagerGalleryComponent.vue?vue&type=script&lang=js"
export * from "./OnePagerGalleryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Desktop/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__